module.exports = __webpack_public_path__ + "static/playfairdisplay-bolditalic-6baade20f4a683135f3f0bcdb3d0612b.woff2";